import React from "react";
import { useSelector } from "react-redux";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardContent,
} from "@ionic/react";
import "./ProjectTiers.css";
import GridList from "../components/GridList";
import WrappedSpinner from "../components/WrappedSpinner";
import Error from "../components/Error";
import { TierInterface, JSONInterface } from "../interfaces/JSONInterface";
import { StateInterface } from "../interfaces/StateInterface";
import { ComponentProps } from "../interfaces/ComponentProps";

const ProjectTiers: React.FC<
  ComponentProps & { fetchProjectsJSON: Function }
> = ({ match, fetchProjectsJSON }) => {
  const json: JSONInterface | null = useSelector(
    (state: StateInterface) => state.data.json
  );
  const loaded: boolean = useSelector(
    (state: StateInterface) => state.data.loaded
  );
  const error: string | null = useSelector(
    (state: StateInterface) => state.data.error
  );
  const numGridCols: number = useSelector(
    (state: StateInterface) => state.layout.numGridCols
  );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Select</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {error ? (
          <Error error={error} onButtonClick={fetchProjectsJSON} />
        ) : loaded ? (
          <GridList
            data={json?.tiers}
            renderItem={(tier: TierInterface) => (
              <IonCard
                button
                key={tier.name}
                className="tiers-card"
                routerLink={`${match.url}/${tier.name}`}
                routerDirection="forward"
              >
                <IonCardContent className="tiers-card-content">
                  <div id="tiers-thumbnail-container">
                    <div id="tiers-thumbnail-element">
                      <img
                        id="tiers-thumbnail-image"
                        alt={tier.name}
                        src={tier.imageUrl}
                      />
                    </div>
                  </div>
                  <h3 className="tiers-text">{tier.name}</h3>
                </IonCardContent>
              </IonCard>
            )}
            numCols={numGridCols}
          />
        ) : (
          <WrappedSpinner />
        )}
      </IonContent>
    </IonPage>
  );
};

export default ProjectTiers;
